import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(marketing)/_PageSections/Pricing.tsx");
